import { toast } from 'react-toastify'
import validateDisposableEmail from '../services/micro/validate_disposable_email'

export const validateEmail = async (email) => {
  const redundantEmails = [
    'gmail.com',
    'yahoo.com',
    'hotmail.com',
    'outlook.com',
    'icloud.com',
    'msn.com',
    'live.com',
    'zoho.com',
    'aol.com',
    'yandex.com',
    'mail.com',
    'inbox.com',
  ]

  if (!email || !email.includes('@')) {
    return {
      validationResults: { email: false },
      invalidEmail: true,
    }
  }

  const [, emailDomain] = email.split('@')

  if (redundantEmails.includes(emailDomain)) {
    toast.error('Invalid Email. Please use a business email address')
    return {
      validationResults: { email: false },
      invalidEmail: true,
    }
  }

  const disposableCheck = await validateDisposableEmail(email)

  if (disposableCheck.isDisposableEmail) {
    toast.error('Invalid Email. Please use a business email address')
    return {
      validationResults: { email: false },
      invalidEmail: true,
    }
  }

  return {
    validationResults: { email: true },
    invalidEmail: false,
  }
}